<section class="jumbotron jumbotron-fluid home-top-jumbotron">
    <div class="container">
        <div *ngIf="title" [innerHTML]="titleSanitized"></div>

        <div *ngIf="text" [innerHTML]="textSanitized"></div>
    </div>
</section>
